import React from "react";
import styles from "./Loader.module.scss";

type LoaderProps = {
  children?: React.ReactNode;
};

export const Loader = ({ children }: LoaderProps) => {
  return (
    <div className={styles["loader-wrapper"]}>
      <BoxLoader />
      {children}
    </div>
  );
};

type BoxLoaderProps = {
  className?: string;
};

export const BoxLoader = ({ className = "" }: BoxLoaderProps) => {
  return (
    <div className={`${styles["box-loader"]} ${className}`}>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
